import React from 'react';

const STATUS_STYLES = {
  open: 'bg-axial-500/20 text-axial-300 border-axial-500/40',
  'in review': 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  'in progress': 'bg-cyan-500/20 text-cyan-300 border-cyan-500/40',
  'ready for review': 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  'amendments required': 'bg-orange-500/20 text-orange-300 border-orange-500/40',
  'ready for signoff': 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
  pending: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
  active: 'bg-cyan-500/20 text-cyan-300 border-cyan-500/40',
  sent: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  acknowledged: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
  completed: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40',
  overdue: 'bg-red-500/20 text-red-300 border-red-500/40',
  closed: 'bg-gray-500/20 text-gray-300 border-gray-500/40',
  delayed: 'bg-orange-500/20 text-orange-300 border-orange-500/40',
  'at risk': 'bg-rose-500/20 text-rose-300 border-rose-500/40',
  'on hold': 'bg-gray-500/20 text-gray-300 border-gray-500/40',
};

function StatusPill({ status }) {
  const normalizedStatus = String(status || '').toLowerCase();
  const style = STATUS_STYLES[normalizedStatus] || 'bg-gray-600/20 text-gray-300 border-gray-600/40';

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide ${style}`}>
      {status}
    </span>
  );
}

export default StatusPill;
